import { render, staticRenderFns } from "./add-entity.vue?vue&type=template&id=5f78e589&scoped=true"
import script from "./add-entity.vue?vue&type=script&lang=js"
export * from "./add-entity.vue?vue&type=script&lang=js"
import style0 from "./add-entity.vue?vue&type=style&index=0&id=5f78e589&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f78e589",
  null
  
)

export default component.exports